const fetch = require("node-fetch");
export default async function () {
	const res = await fetch("https://prevalent.bamboohr.com/jobs/embed2.php");
	const data = await res.json();
	return (data.departments || []).map((dep) => ({
		department: dep.label,
		jobs: dep.positions.map((p) => ({
			title: p.name.trim(),
			link: p.url,
			location: p.location,
		})),
	}));
}
